"use client"

import { useState } from "react"
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog"
import { Button } from "../ui/button"
import { MessageCircle, Send, PartyPopper, Phone, X, ChevronLeft, ChevronRight } from "lucide-react"
import { cn } from "../../../lib/utils"
import { DataItem, useOperador } from "../../../context/OperadorContext"
import { useAuth } from "../../../context/AuthContext"
import { isCelularValidoBR } from '../../../utils/validaTelefone'
import jwtDecode from "jwt-decode"
import { format, subDays } from "date-fns"
import { Spinner } from "../ui/spinner"
import { useWhatsAppCampaign } from "../../../context/WhatsAppCampaignContext"
import moment from "moment"

interface WhatsAppCampaignModalProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  totalClients: number
  fila: DataItem[]
}

interface SendCampanha {
  id_campanha: number,
  item_campanha: [
    {
      id_item_campanha: number,
      status: string
      fila: string
      cpf_cnpj: string
    }
  ]
}

const templates = [
  {
    id: 1,
    category: "Utility",
    name: "lj_021225",
    message: `🚨 Atenção {NOME} 🚨
 
Não identificamos o pagamento da sua compra com a Gazin.
 
Nome: {NOME}
Contrato: {CONTRATO}
Data de vencimento: {VENCIMENTO}
 
Caso já tenha efetuado o pagamento, favor desconsiderar.`,
    actions: ["Falar com o atendente.", "Não receber mensagens"],
  },

  //   {
  //     id: 2,
  //     category: "Utility",
  //     name: "lj_reserva1",
  //     message: `Olá {NOME}, você tem um pagamento em atraso com a GAZIN.

  // Nome: {NOME}
  // Documento: {DOCUMENTO}
  // Data de vencimento: {VENCIMENTO}

  // Use o botão abaixo para concluir o pagamento.

  // Por favor ignore esta mensagem se você já pagou.`,
  //     actions: ["Falar com atendente", "Não receber mensagem"],
  //   },

  //   {
  //     id: 3,
  //     category: "Utility",
  //     name: "lj_reserva2",
  //     message: `🎉 Atenção {NOME} 🎉

  // Não identificamos o pagamento da sua compra com a Gazin.

  // Nome: {NOME}
  // Documento: {DOCUMENTO}
  // Data de vencimento: {VENCIMENTO}

  // Importante realizar o pagamento hoje.

  // Caso já tenha efetuado o pagamento, favor desconsiderar.`,
  //     actions: ["Falar com atendente", "Não receber mensagem"],
  //   },
]

export function WhatsAppCampaignModal({ open, onOpenChange, totalClients, fila }: WhatsAppCampaignModalProps) {
  const [selectedTemplateIndex, setSelectedTemplateIndex] = useState(0)
  const selectedTemplate = templates[selectedTemplateIndex]
  const { createCampanhaWhats, loadingCampanha, findCampanhaWhats, sendCampanhaAPI, filtros, loadData, loadCampanhas } = useOperador()
  const { cookies, } = useAuth()
  const decoded = jwtDecode(cookies?.token || '') as any;
  const [confirmOpen, setConfirmOpen] = useState(false)
  const { setHasCampaign } = useWhatsAppCampaign()
  const botId = '69863a02fab55dc4878dfbd1'


  const [loading, setLoading] = useState(false)
  const handlePrevious = () => {
    setSelectedTemplateIndex((prev) => (prev > 0 ? prev - 1 : templates.length - 1))
  }

  const handleNext = () => {
    setSelectedTemplateIndex((prev) => (prev < templates.length - 1 ? prev + 1 : 0))
  }

  // const handlePesquisa = async () => {
  //   const data = await findCampanhaWhats('02780156112')
  //   console.log(data)
  // }

  function adaptarItemFila(f: DataItem) {
    const hoje = new Date();

    const dataVencimento = format(
      subDays(hoje, f.atraso),
      'dd/MM/yyyy'
    );

    const telefones = [
      f.fone1,
      f.fone2,
      f.fone3,
      f.fone4,
      f.fone5,
      f.fone6,
      f.fone7,
      f.fone8,
    ];

    const telefoneValido = telefones.find(isCelularValidoBR);

    return {
      ...f,
      telefoneWhatsapp: telefoneValido ? `55${telefoneValido}` : '',
      dataVencimento,
    };
  }

  const filaNormalizada = fila.map(adaptarItemFila);

  const sendCampanha = async (data: SendCampanha) => {
    const campanhaTemplate = filaNormalizada.map(f => {
      const find = data.item_campanha.find(item => f.cpf_cnpj === item.cpf_cnpj)
      return {
        // "from": '366f62ec-dc47-4017-b9c4-6126e271006f',
        "from": '1030276093495793',
        "to": `${f.telefoneWhatsapp}`,
        "id": find?.id_item_campanha,
        // "type": "positus",
        "type": "meta",
        "namespace": '20898fe9_78fd_4722_9014_5c7c3ea4a4ae',
        "template": selectedTemplate.name,
        "vars": [
          {
            "type": "text",
            "key": "dev.prinome",
            "value": f.nome_cliente?.trim().split(' ')[0] || '',
          },
          {
            "type": "text",
            "key": "dev.nome",
            "value": f.nome_cliente
          },
          {
            "type": "text",
            "key": "fat.documento",
            "value": f.cpf_cnpj
          },
          {
            "type": "text",
            "key": "fat.data1parc",
            "value": f.dataVencimento
          },

        ]
      }
    })
    // console.log("Chegou aqui campanhaTemplate", campanhaTemplate)
    await sendCampanhaAPI(campanhaTemplate as [])
  }


  const handleSend = async () => {
    setLoading(true)
    try {
      const filaCampanha = filaNormalizada.map(f => {
        return {
          cpf_cnpj: f.cpf_cnpj,
          telefone: f.telefoneWhatsapp,
          valor_vencer: f.valor_a_vencer,
          valor_vencido: f.valor_vencido,
          atraso: f.atraso
        }
      })
      const data = await createCampanhaWhats({
        fila: filaCampanha,
        cod_namespace: '17eb5f88_4eb3_438b_b73f_54c9c9add03e',
        cod_template: 'lj_021225',
        cod_numero: '682340951635373',
        custo: 0.07,
        id_loja: decoded?.id_loja,
        id_tipo_template: 1,
        id_fila: cookies?.whatsapp?.queueId || '',
        botId
      }) as unknown as SendCampanha

      await sendCampanha(data)
      await loadCampanhas(decoded?.id_loja)
      await loadData({
        ...filtros,
        data_producao: moment(new Date())
          .tz("America/Sao_Paulo")
          .format("YYYY-MM-DD")
      });
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
      onOpenChange(false)
    }
  }



  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-3xl w-[90vw] max-h-[85vh] overflow-hidden flex flex-col p-0">
        <DialogHeader className="border-b px-6 py-4 shrink-0">
          <DialogTitle className="flex items-center gap-2 text-lg font-semibold text-[#1e3a5f]">
            <MessageCircle className="h-5 w-5 text-green-600" />
            Gerar Campanha WhatsApp
          </DialogTitle>
        </DialogHeader>

        <div className="text-center py-3 border-b bg-gray-50">
          <span className="text-sm text-gray-600 bg-white px-4 py-1.5 rounded-full border shadow-sm">
            {selectedTemplateIndex + 1} de {templates.length} - {selectedTemplate.category}
          </span>
        </div>

        <div className="flex-1 overflow-y-auto p-6">
          <div className="flex items-center justify-center gap-4">
            {/* Previous button */}
            <button
              onClick={handlePrevious}
              className="p-2 rounded-full bg-gray-100 hover:bg-gray-200 transition-colors"
            >
              <ChevronLeft className="h-6 w-6 text-gray-600" />
            </button>

            {/* Template Preview */}
            <div className="flex-1 max-w-md">
              <div
                className="rounded-xl p-4 shadow-inner"
                style={{
                  backgroundColor: "#e5ddd5",
                  backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fillRule='evenodd'%3E%3Cg fill='%23d4ccc4' fillOpacity='0.4'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
                }}
              >
                <div className="bg-white rounded-lg shadow-md overflow-hidden">
                  <div className="flex items-center justify-center gap-2 py-3 px-4 bg-gray-50 border-b">
                    <PartyPopper className="h-4 w-4 text-amber-500" />
                    <span className="font-bold text-sm text-gray-800">{selectedTemplate.name}</span>
                    <PartyPopper className="h-4 w-4 text-amber-500" />
                  </div>

                  <div className="p-4 text-sm text-gray-700 leading-relaxed">
                    {selectedTemplate.message.split("\n").map((line, index) => {
                      const highlightedLine = line.replace(
                        /\{([^}]+)\}|(\d{4} \d{3} \d{4})|R\$ [\d.,]+|Gazin/g,
                        (match) => `<span class="text-blue-600 font-medium">${match.replace(/[{}]/g, "")}</span>`,
                      )
                      return (
                        <span
                          key={index}
                          dangerouslySetInnerHTML={{
                            __html:
                              highlightedLine +
                              (index < selectedTemplate.message.split("\n").length - 1 ? "<br/>" : ""),
                          }}
                        />
                      )
                    })}
                  </div>

                  <div className="border-t">
                    {selectedTemplate.actions.map((action, index) => (
                      <button
                        key={index}
                        className={cn(
                          "w-full py-3 text-sm text-blue-600 hover:bg-blue-50 flex items-center justify-center gap-2 transition-colors",
                          index < selectedTemplate.actions.length - 1 && "border-b",
                        )}
                      >
                        {index === 0 ? <Phone className="h-4 w-4" /> : <X className="h-4 w-4" />}
                        {action}
                      </button>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            {/* Next button */}
            <button onClick={handleNext} className="p-2 rounded-full bg-gray-100 hover:bg-gray-200 transition-colors">
              <ChevronRight className="h-6 w-6 text-gray-600" />
            </button>
          </div>

          {/* Template dots indicator */}
          <div className="flex justify-center gap-2 mt-4">
            {templates.map((_, index) => (
              <button
                key={index}
                onClick={() => setSelectedTemplateIndex(index)}
                className={cn(
                  "w-2.5 h-2.5 rounded-full transition-colors",
                  index === selectedTemplateIndex ? "bg-green-600" : "bg-gray-300 hover:bg-gray-400",
                )}
              />
            ))}
          </div>
        </div>

        <div className="border-t px-6 py-4 bg-gray-50 shrink-0">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-4">
              <div className="bg-white border px-4 py-2 rounded-lg shadow-sm">
                <p className="text-xs text-gray-500">Clientes para envio</p>
                <p className="text-xl font-bold text-[#1e3a5f]">{totalClients}</p>
              </div>
            </div>
            <div className="flex gap-3">
              <Button variant="outline" onClick={() => onOpenChange(false)} className="px-6 h-10 ">
                Cancelar
              </Button>
              <Button onClick={() => setConfirmOpen(true)} className="bg-green-600 hover:bg-green-700 text-white px-6 h-10 gap-2">
                {
                  loadingCampanha || loading ? (
                    <Spinner />
                  ) : (
                    <>
                      <Send className="h-4 w-4" />
                      Enviar Campanha
                    </>
                  )
                }
              </Button>
            </div>
          </div>
        </div>
      </DialogContent>

      <Dialog open={confirmOpen} onOpenChange={setConfirmOpen}>
        <DialogContent className="max-w-md text-center">
          <DialogHeader>
            <DialogTitle className="text-lg font-semibold text-green-600 text-center">
              Confirmar envio
            </DialogTitle>
          </DialogHeader>

          <div className="py-4  text-gray-600">
            Você está prestes a enviar a campanha para{" "}
            <span className="font-bold text-gray-800">{totalClients}</span> clientes.

            <br /><br />

            Essa ação <span className="font-bold text-red-600">não pode ser desfeita</span>.
            Deseja continuar?
          </div>

          <div className="flex justify-end gap-3">
            <Button
              variant="outline"
              onClick={() => setConfirmOpen(false)}
            >
              Cancelar
            </Button>

            <Button
              className="bg-green-600 hover:bg-green-700 text-white"
              onClick={async () => {
                setConfirmOpen(false)
                await handleSend()
              }}
            >
              Confirmar e enviar
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </Dialog>
  )
}
